import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Login from 'components/authentication/Login';
import ForgotPassword from 'components/authentication/ForgotPassword';
import ChangePassword from 'components/authentication/ChangePassword';

const AuthRoutes: React.FC = () => {
   return (
      <Switch>
         {/* Auth */}
         <Route path='/login/recuperar-password/:token' component={ChangePassword} />
         <Route path='/login/recuperar-password' component={ForgotPassword} />
         <Route path='/login' component={Login} />
      </Switch>
   );
};

export default AuthRoutes;
